// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1nY8U","label":"Labeled_label__2KDkO","divider":"Labeled_divider__1Vf7Z"};